import { render, staticRenderFns } from "./BuyUserItem.vue?vue&type=template&id=1519bd30&scoped=true&"
import script from "./BuyUserItem.vue?vue&type=script&lang=js&"
export * from "./BuyUserItem.vue?vue&type=script&lang=js&"
import style0 from "./BuyUserItem.vue?vue&type=style&index=0&id=1519bd30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1519bd30",
  null
  
)

export default component.exports